import { render, staticRenderFns } from "./redactors.vue?vue&type=template&id=4a5ddc48&scoped=true"
import script from "./redactors.vue?vue&type=script&lang=js"
export * from "./redactors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5ddc48",
  null
  
)

export default component.exports